import type { TFunction } from '@mint-lib/i18n';

import type { ChipProps } from '@myn/mui';

import type { ValueOf } from './shared.js';

export const ModalType = {
  LIST: 'list',
  LIST_WITH_NEW: 'list_with_new',
  EXISTING: 'existing',
  CREATION: 'creation',
  DEFAULT: 'default',
} as const;

export type IOId = {
  ioId: number | null;
  name: string | null;
};

export type IOModalData = {
  ioData: IOId[];
  buyingPlanId: number;
  buyingPlanItemId: number;
};

export enum IOStatuses {
  UNSENT = 'unsent',
  MISSING_DATA = 'missing_data',
  SENT = 'sent',
  DECLINED = 'rejected',
  BOOKED = 'approved',
}

export type IOStatusChip = {
  label: string;
  tooltip: string;
  color: ChipProps['color'];
};

export type GetModalContent = {
  t: TFunction;
  type: string;
  data?: IOModalData | null;
  selectInsertionOrder: (itemId?: number | null) => void;
  toggleDoNotShowAgain: () => void;
};

export type IOModalsType = ValueOf<typeof ModalType>;

export type IOModal = {
  isOpen: boolean;
  type: IOModalsType;
  data: IOModalData | null | undefined;
};

export type GetIOInfo = {
  buyingPlanId: number;
  buyingPlanItemId: number;
};

export type NewIOType = {
  buyingPlanId: number;
  buyingPlanItemId: number;
  ioId?: number | null;
};

export type TooltipConditions = {
  hasSubRows: boolean;
  isIoCanBeSent?: boolean;
  isPlatformLevel: boolean;
  isLoading: boolean;
  isValidIoGroup: boolean;
  isBuyingPlanApproved: boolean;
  isUserPartOfIoGroup: boolean;
  isReadOnlyUser: boolean;
};
